import React from 'react';

import {
  Box,
  IconButton,
  useBreakpointValue,
  Stack,
  Heading,
  Container,
} from '@chakra-ui/react';
// Here we have used react-icons package for the icons
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
// And react-slick as our Carousel Lib
import Slider from 'react-slick';
import { Tools } from './tools';

// Settings for the slider
const settings = {
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export const Skills = () => {
  // As we have used custom buttons, we need a reference variable to
  // change the state
  const [slider, setSlider] = React.useState(null); //<Slider | null>

  // These are the breakpoints which changes the position of the
  // buttons as the screen size changes
  const top = useBreakpointValue({ base: '90%', md: '50%' });
  const side = useBreakpointValue({ base: '30%', md: '40px' });

  // This list contains all the data for carousels
  // This can be static or loaded from a server
  const cards = [
    {
      title: 'HTML',
      image:
        'https://cdn3d.iconscout.com/3d/free/thumb/html-logo-6563588-5453024.png?f=webp',
    },
    {
      title: 'CSS',
      image:
        'https://cdn3d.iconscout.com/3d/free/thumb/css-logo-6563485-5453030.png',
    },
    {
      title: 'JavaScript',
      image:
        'https://static.vecteezy.com/system/resources/previews/012/697/298/non_2x/3d-javascript-logo-design-free-png.png',
    },
    {
      title: 'React',
      image:
        'https://cdn3d.iconscout.com/3d/free/thumb/react-native-5562339-4642743.png',
    }, {
      title: 'Redux',
      image:
        'https://repository-images.githubusercontent.com/347723622/92065800-865a-11eb-9626-dff3cb7fef55',
    }, {
      title: 'Type-Script',
      image:
        'https://w7.pngwing.com/pngs/915/519/png-transparent-typescript-hd-logo-thumbnail.png',
    }, {
      title: 'Node.js',
      image:
        'https://cdn-icons-png.flaticon.com/512/919/919825.png',
    }, {
      title: 'Express.js',
      image:
        'https://www.nextontop.com/assets/img/services/web/expressjs.svg',
    },
    {
      title: 'MongoDB',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSw9cDw4coZijELKpCkDVi7ItmEP1CAxtzyOOm1cYd_Rg&usqp=CAU&ec=48665701',
    },
    {
      title: 'DSA',
      image:
        'https://w7.pngwing.com/pngs/580/809/png-transparent-data-structure-logo-brand-data-structure-blue-text-logo.png',
    },
    {
      title: 'React Router',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwLq7oAaEf0OSnwEjISs6UZbZBkbkwIUV7Rw&usqp=CAU',
    }, {
      title: 'Axios',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRaTyuFXQDDOUPdafq8kkiBQ1Ai-ovU_avXecDIkszkPTeOxZ5R8H8g99xl6vRfQH-w4BA&usqp=CAU',
    },
    {
      title: 'Chakra UI',
      image:
        'https://d2eip9sf3oo6c2.cloudfront.net/playlists/square_covers/000/505/265/square_480/chakra-lv1.png',
    }
  ];

  return (
    <Box margin={"100px 0px -50px 0px"}  id='skills' 
 
    >
      <Box>
        <Heading fontWeight={600} fontSize={'40px'}
        // fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
        >
          Skills
        </Heading>
        <Box
          position={'relative'}
          height={'700px'}
          width={'full'}
          overflow={'hidden'}>
          {/* CSS files for react-slick */}
          <link
            rel="stylesheet"
            type="text/css"
            charSet="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
          />
          {/* Left Icon */}
          <IconButton
            aria-label="left-arrow"
            variant="ghost"
            position="absolute"
            left={side}
            top={top}
            transform={'translate(0%, -250%)'}
            zIndex={2}
            onClick={() => slider?.slickPrev()}>
            <BiLeftArrowAlt size="40px" />
          </IconButton>
          {/* Right Icon */}
          <IconButton
            aria-label="right-arrow"
            variant="ghost"
            position="absolute"
            right={side}
            top={top}
            transform={'translate(0%, -250%)'}
            zIndex={2}
            onClick={() => slider?.slickNext()}>
            <BiRightArrowAlt size="40px" />
          </IconButton>
          {/* Slider */}
          <Slider {...settings} ref={(slider) => setSlider(slider)}>
            {cards.map((card, index) => (
              <Box
                key={index}
                height={'s'}
                position="sticky"
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                backgroundSize="300px"
                backgroundImage={`url(${card.image})`}
              >
                {/* This is the block you need to change, to customize the caption */}
                <Container size="container.lg" height="500px" position="relative">
                  <Stack
                    spacing={6}
                    w={'full'}
                    maxW={'lg'}
                    position="relative"
                    top="85%"
                    transform="translate(0, -50%)">
                    <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
                      {card.title}
                    </Heading>
                  </Stack>
                </Container>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
      <hr/>
      <Tools />
    </Box>
  );
}